import axios from "axios";
import { ApiResponse } from "../types/api/general";
import { get, post } from "./api";
import { HandleNewResponse, HandleNewErrorResponse, HandleAltResponse } from "./handlers";
import AuthApi from "./auth";
import FileSaver from "file-saver";
import { ENROLLMENT_KEYS } from "../constants/enums";
import { HTTP_STATUS_CODES } from "../constants/api";

const enrollmentHeaders = () => {
  const config = {
    Authorization: `Bearer ${localStorage.getItem(
      ENROLLMENT_KEYS.ACCESS_TOKEN_KEY
    )}`,
    "Access-Control-Allow-Origin": "*",
  };

  return config;
}

export const GetApiData = async <T>(
  url: string,
  extraHeaders?: Record<string, string>
): Promise<T> => {
  try {
    const response = (extraHeaders
      ? await get(url, extraHeaders)
      : await get(url)) as ApiResponse;
    return HandleNewResponse(response);
  } catch (error) {
    return HandleNewErrorResponse(error);
  }
};

export const PostApiData = async <TRequest, TResponse>(url: string, body: TRequest, extraHeaders?: Record<string, string>): Promise<TResponse> => {
  try {
    let response = extraHeaders
      ? await post(url, body, extraHeaders) as ApiResponse
      : await post(url, body) as ApiResponse;
    if (response.status === HTTP_STATUS_CODES.VALIDATION_ERROR) {
      throw response;
    }
    return HandleNewResponse(response);
  } catch (error) {
    return HandleNewErrorResponse(error);
  }
}

export const PostApiWorkflowData = async <TRequest, TResponse>(
  url: string,
  body: TRequest,
  extraHeaders?: Record<string, string>
): Promise<{ status: number; data: TResponse }> => {
  try {
    const response = extraHeaders
      ? await post(url, body, extraHeaders) as ApiResponse
      : await post(url, body) as ApiResponse;
    if (response.status === HTTP_STATUS_CODES.VALIDATION_ERROR) {
      return { status: response.status, data: response.data };
    }
    return { status: response.status, data: HandleNewResponse(response) };
  } catch (error) {
    return HandleNewErrorResponse(error);
  }
};

export const GetApiReceiptData = async <T>(url: string, filename: string): Promise<T> => {
  try {
    const response = await axios.get(url, {
      headers: AuthApi.getAuthorizationHeaders(),
      responseType: "blob",
    });

    await FileSaver.saveAs(new Blob([response.data]), filename);

    return HandleNewResponse(response);
  } catch (error) {
    return HandleNewErrorResponse(error);
  }
}

export const PostEnrollmentApiData = async <T>(url: string, body: T): Promise<T> => {
  try {
    let response = await axios.post(
      url,
      body,
      {
        headers: enrollmentHeaders(),
      }
    );

    return HandleAltResponse(response);
  } catch (err) {
    return HandleNewErrorResponse(err);
  }
}